import gql from "graphql-tag";
import {useCallback} from "react";

import {useMutation} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {
    addFavoritedTeacherTool,
    addFavoritedTeacherToolVariables,
} from "./__graphql-types__/addFavoritedTeacherTool.ts";

export const ADD_FAVORITED_TEACHER_TOOL_MUTATION: GqlOperation<
    addFavoritedTeacherTool,
    addFavoritedTeacherToolVariables
> = gqlOp(gql`
    mutation addFavoritedTeacherTool($toolID: ID!, $configName: String!) {
        aiGuideAddFavoritedTeacherTool(
            toolID: $toolID
            configName: $configName
        ) {
            favoritedTool {
                id
                configName
            }
            error {
                code
                debugMessage
            }
        }
    }
`);

export const useAddFavoritedTeacherTool = (): ((
    variables: addFavoritedTeacherToolVariables,
) => Promise<void>) => {
    const [mutate] = useMutation(ADD_FAVORITED_TEACHER_TOOL_MUTATION);

    return useCallback(
        async (variables: addFavoritedTeacherToolVariables) => {
            try {
                const result = await mutate(variables);

                if (result.status === "success" && result.data) {
                    const error =
                        result.data.aiGuideAddFavoritedTeacherTool?.error?.code;
                    if (error) {
                        throw new KAError(error, Errors.Internal);
                    }
                }
            } catch (error: any) {
                if (error instanceof KAError) {
                    throw error;
                }

                throw new KAError(
                    "Failed to add favorited teacher tool",
                    Errors.Internal,
                );
            }
        },
        [mutate],
    );
};
